import { useMemo } from 'react';

import { usePermissions } from '../../../../front/src/hooks/usePermissions';
import type { User } from '../../../../front/src/types/api';

export const useChatUsers = ({ users }: { users: User[] }) => {
  const { authUserId } = usePermissions();
  return useMemo(() => users.filter(u => u.id !== authUserId), [users, authUserId]);
};
